export const TutorialsRow = {
  extends: 'Group',
  background: 'highlight-reversed',
  padding: 'A1 B1',
  margin: '- -B1',
  round: 'A2',
  gap: 'A2',
  hide: (el, s) => s.hideTutorials,
  ':hover .hide': {
    opacity: 1
  },
  // The "Hide" control rests at opacity: 0 and the rule above is its only
  // reveal — and since smbls e3333d298 every `:hover` rule is wrapped in
  // `@media (hover: hover)`, that reveal never runs on touch. Without this a
  // phone user can never dismiss the Getting Started row.
  '@coarse': {
    '.hide': {
      opacity: 1
    }
  },
  Title: {
    flow: 'x',
    align: 'center space-between',
    text: '{{ learn.gettingStarted.title | polyglot }}',
    IconText: {
      class: 'hide',
      opacity: '0',
      text: '{{ learn.gettingStarted.hide | polyglot }}',
      icon: 'eyeClosed',
      gap: 'Y1',
      transition: 'A defaultBezier opacity',
      cursor: 'pointer',
      ':hover': {
        textDecoration: 'underline'
      },
      onClick: (ev, el, s) => {
        el.call('setCookie', 'hideTutorialsDashboard', 'true', 365)
        s.toggle('hideTutorials', {
          preventUpdate: ['ChooseProject']
        })
      }
    }
  },
  Scrollable: {
    paddingInline: '0',
    margin: '- -B',
    padding: '- - - B',
    maxWidth: 'auto',
    width: 'auto',
    gap: 'C',
    ':before, &:after': {
      content: '""',
      widthRange: '1px'
    },
    childExtends: 'TutorialsRowItem',
    childrenAs: 'state',
    children: [
      {
        text: 'learn.videoRow.gettingStarted',
        youtubeId: 'jYU0soXY-To',
        duration: '14:31'
      },
      {
        text: 'learn.videoRow.symbolsLibrary',
        youtubeId: '1Vut-DOrfvg',
        duration: '1:50'
      },
      {
        text: 'learn.videoRow.whatIsSymbols',
        youtubeId: 'P_jjCTzS0-w',
        duration: '1:15'
      },
      {
        text: 'learn.videoRow.navigation',
        youtubeId: 'rugrjZ6WrDM',
        duration: '4:25'
      },
      {
        text: 'learn.videoRow.components',
        youtubeId: 'ScXOBnJ6ZIU',
        duration: '2:31'
      },
      {
        text: 'learn.videoRow.pages',
        youtubeId: '-qWxYRR15DM',
        duration: '0:56'
      },
      {
        text: 'learn.videoRow.calculator',
        youtubeId: 'dPZCwGEysdI',
        duration: '5:23'
      },
      {
        text: 'learn.videoRow.codeEditor',
        youtubeId: 'W2sEhoLA0Dc',
        duration: '0:23'
      },
      {
        text: 'learn.videoRow.files',
        youtubeId: 'P9D8A0258Ro',
        duration: '1:58'
      },
      {
        text: 'learn.videoRow.colors',
        youtubeId: 'i4JuUp39n50',
        duration: '2:02'
      },
      {
        text: 'learn.videoRow.spacing',
        youtubeId: 'xFgl6jG2yrw',
        duration: '2:35'
      },
      {
        text: 'learn.videoRow.icons',
        youtubeId: 'rPfSew0RGZc',
        duration: '2:19'
      }
    ]
  },
  Scrollbar: {
    extends: 'Scrollbar.scrollable'
  }
}
